<dx-popup
    #attachments
    minWidth="150px"
    minHeight="150px"
    width="50%"
    height="40%"
    title="Attachments"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [(visible)]="visible"
    (onShown)="onShown($event)"
    (onHidden)="onHidden()"
>
    <dx-box height="100%" width="100%" direction="col">
        <dxi-item [ratio]="1">
            <dx-data-grid
                width="100%"
                height="100%"
                [dataSource]="attachmentData"
                [allowColumnReordering]="true"
                [allowColumnResizing]="true"
                [columnAutoWidth]="true"
                [showBorders]="true"
                [showColumnLines]="true"
                [showRowLines]="true"
                noDataText="No data to display"
            >
                <dxi-column caption="File Name" dataType="string" cellTemplate="fileNameTemplate"></dxi-column>

                <div *dxTemplate="let row of 'fileNameTemplate'">
                    <div class="cc-hyper-link">
                        <span class="document-tree-icon">
                            <i class="cc-1-5x" [ngClass]="getFileIconByExtension(row.data)"></i>
                        </span>
                        <span class="document-tree-content">
                            <a href="javascript:void(0)" (click)="onDownloadClick(row.data)">
                                {{ row.data.fileName }}
                            </a>
                        </span>
                    </div>
                </div>
            </dx-data-grid>
        </dxi-item>

        <dxi-item baseSize="auto">
            <dx-toolbar width="100%" class="attachment-button-container">
                <dxi-item location="before">
                    <div *dxTemplate>
                        <dx-button type="default" text="Close" [icon]="iconClose" (onClick)="onPopClose()"></dx-button>
                    </div>
                </dxi-item>
            </dx-toolbar>
        </dxi-item>
    </dx-box>
</dx-popup>
